import { AbstractControl } from "@angular/forms";
import { Injectable } from "@angular/core";
import { EmployeeMasterService } from "../../Services/employee-master.service";

@Injectable()
export class EmployeeMasterValidators {
  constructor(private service: EmployeeMasterService) {}

  shouldBeUnique(ac: AbstractControl) {
    // ac will hold each of the form controls
    const employeeNumber = ac.get("employeeNumber").value;

    if (employeeNumber != null) {
      this.service.checkForDuplicate(employeeNumber).subscribe(
        (response) => {
          if (response.length > 0)
            ac.get("userID").setErrors({ isDuplicate: true });
          else ac.get("userID").setErrors(null);
        },
        (error) => {
          ac.get("userID").setErrors(null);
        }
      );
    }
  }
}
